import { CalendarDaysIcon, HomeIcon } from "@heroicons/react/24/solid";
import { Tag } from "lucide-react";
import { CiWarning } from "react-icons/ci";
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { MdDashboardCustomize } from "react-icons/md";

export const getMenuItems = (
  profile: any,
  stats: any,
  path: string,
  customer_id: string,
  is_customer: boolean | undefined
) => {
  const normalizedPath = path.replace(/\/$/, "");

  return [
    {
      to: "/client/dashboard",
      icon: <MdDashboardCustomize className="h-5 w-9" />,
      label: "Mon compte",
      condition: true,
    },
    {
      to: "/client/demande",
      icon: <HomeIcon className="h-5 w-9" />,
      label: "Mes espaces",
      condition: profile?.validation === "en cours",
    },
    {
      to: "/client/locations",
      icon: <HomeIcon className="h-5 w-9" />,
      label: "Mes espaces",
      condition: profile?.validation === "approuvé",
    },
    {
      to: "/client/mes-reservations",
      icon: <CalendarDaysIcon className="h-5 w-9" />,
      label: "Mes réservations",
      condition: profile?.validation === "approuvé" && is_customer !== true,
    },
    {
      to: "/client/evenements",
      icon: <CalendarDaysIcon className="h-5 w-9" />,
      label: "Mes événements",
      condition: profile?.validation !== "approuvé",
    },
    {
      to: "/client/mes-evenements",
      icon: <CalendarDaysIcon className="h-5 w-9" />,
      label: "Mes événements",
      condition: profile?.validation === "approuvé" && stats?.ownerEvents >= 1,
    },
    {
      to: "/client/list-pending-reservations",
      icon: <CalendarDaysIcon className="h-5 w-9" />,
      label: "Demande de Réservations",
      condition: profile?.validation === "approuvé" && is_customer !== true,
    },
    {
      to: "/client/transferts-reservations",
      icon: <FaArrowRightArrowLeft className="h-5 w-9" />,
      label: "Paiement / versement",
      condition: profile?.validation === "approuvé" && is_customer !== true,
      className:
        normalizedPath.includes("/client/transferts-reservations") ||
        normalizedPath.includes("/client/transferts-reservations-gain") ||
        normalizedPath.includes("/client/transactions")
          ? "font-bold text-eventToBee"
          : "",
    },
    {
      to: "/client/factures",
      icon: <CalendarDaysIcon className="h-5 w-9" />,
      label: "Factures",
      condition: profile?.validation !== "approuvé",
    },
    {
      to: "/client/factures",
      icon: <CalendarDaysIcon className="h-5 w-9" />,
      label: "Factures",
      condition: profile?.validation === "approuvé" && stats?.ownerEvents >= 1,
    },
    {
      to: "/client/reclamations-reservations",
      icon: <CiWarning className="h-5 w-9" />,
      label: "Réclamations",
      condition: true,
    },
    {
      to: "/client/abonnement",
      icon: <Tag className="h-5 w-9" />,
      label: "Abonnement",
      condition: customer_id,
    },
    {
      to: "/client/paramètre-abonnement",
      icon: <Tag className="h-5 w-9" />,
      label: "Paramètre d'abonnement",
      condition: customer_id,
    },
  ];
};
